import { PreviewsNewsCriticsContext } from "contexts/MightyTool";
import { useContext } from "react";
const usePreviewsNewsCritics = () => useContext(PreviewsNewsCriticsContext);
export default usePreviewsNewsCritics;
